import { alpha, createTheme, type Theme } from "@mui/material/styles";
import WeaveBrandTheme from "./WeaveBrandTheme";

// Get values from WeaveBrandTheme
const weaveTheme = WeaveBrandTheme.light;

// To override MUI defaults
const theme = createTheme({
    palette: {
        primary: {
            main: weaveTheme.palette.primary.main,
        },
        error: {
            main: weaveTheme.palette.error.main,
        },
        success: {
            main: weaveTheme.palette.success.main,
        },
        info: {
            main: weaveTheme.palette.info.main,
        },
        warning: {
            main: weaveTheme.palette.warning.main,
        },
    },
    typography: {
        fontFamily: weaveTheme.typography.fontFamily,
    },
    // Override component styles
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    boxShadow: "none", // No drop shadow
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    fontFamily: weaveTheme.typography.fontFamily,
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                popper: {
                    "&.MuiTooltip-popper[data-popper-placement*='right']": {
                        "& .MuiTooltip-tooltip": {
                            marginLeft: "17px",
                        },
                    },
                    "&.MuiTooltip-popper[data-popper-placement*='left']": {
                        "& .MuiTooltip-tooltip": {
                            marginRight: "4px",
                        },
                    },
                },
                tooltip: {
                    backgroundColor: "#666666",
                    borderRadius: "2px",
                    padding: "8px 12px",
                    "& p": {
                        fontSize: "12px",
                        color: "#fff",
                        maxWidth: 220,
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: "4px",
                    fontWeight: "600",
                    minWidth: "64px",
                    lineHeight: "1.25",
                    paddingBottom: "6.25px",
                    paddingLeft: "0.75rem",
                    paddingRight: "0.75rem",
                    paddingTop: "6.25px",
                    textTransform: "none",
                },
                contained: {
                    backgroundColor: "#000000",
                },
                containedError: {
                    backgroundColor: "#D74E26",
                    color: "white",
                    "& .MuiSvgIcon-root": {
                        color: "white",
                    },
                    "&:hover": {
                        backgroundColor: "#D74E26",
                        color: "white",
                    },
                },
                outlined: {
                    border: "1px solid #000000",
                    color: "#000000",
                    "&:hover": {
                        backgroundColor: "white",
                        color: "#000000",
                    },
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    borderRadius: "2px",
                    color: weaveTheme.palette.text.secondary,
                    "&:hover": {
                        color: weaveTheme.palette.primary.main,
                    },
                },
            },
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    color: "black",
                    "&.Mui-checked": {
                        color: "black",
                    },
                },
            },
        },
    },
});

// Add alpha function to theme for MUI v7 compatibility
// Some MUI components internally use theme.alpha() for opacity calculations
// We need to attach it before the theme is used by components
// Use Object.defineProperty to ensure it's not lost when theme is cloned
Object.defineProperty(theme, "alpha", {
    value: alpha,
    writable: false,
    enumerable: true,
    configurable: false,
});

export const FsrMuiTheme: Theme = theme;
